/* lp40sub-c — 個数 × お届け間隔の選択UI
 * JavaScript が無効・失敗しても、Liquid 側が既定値（40個・月1回）の
 * 正しい購入URLを href に出力済みなので CTA はそのまま機能する。 */
(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-s40c]');
  if (!roots.length) return;

  function yen(n) {
    return Number(n).toLocaleString('ja-JP');
  }

  function init(root) {
    var buyBase = root.getAttribute('data-buy-base') || '';
    var qtyInputs = root.querySelectorAll('input[name="s40c-qty"]');
    var freqInputs = root.querySelectorAll('input[name="s40c-freq"]');
    if (!qtyInputs.length || !freqInputs.length) return;

    var ctas = root.querySelectorAll('[data-s40c-cta]');
    var elTotal = root.querySelectorAll('[data-s40c-total]');
    var elBreak = root.querySelectorAll('[data-s40c-breakdown]');
    var elLabel = root.querySelector('[data-s40c-planlabel]');
    var elUnit = root.querySelector('[data-s40c-unit]');
    var fabTotal = root.querySelector('[data-s40c-fab-total]');
    var fabPlan = root.querySelector('[data-s40c-fab-plan]');
    var fabBreak = root.querySelector('[data-s40c-fab-breakdown]');

    function checked(list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].checked) return list[i];
      }
      return list[0];
    }

    function sync() {
      var q = checked(qtyInputs);
      var f = checked(freqInputs);
      if (!q || !f) return;

      var qty = q.getAttribute('data-qty');
      var variant = q.getAttribute('data-variant');
      var price = q.getAttribute('data-price');
      var ship = q.getAttribute('data-ship');
      var total = q.getAttribute('data-total');
      var unit = q.getAttribute('data-unit');
      var plan = f.getAttribute('data-plan');
      var freqKey = f.getAttribute('data-freq');
      var freqLabel = f.getAttribute('data-label');
      var packs = Number(qty) / 10;

      var href = buyBase + '?id=' + encodeURIComponent(variant) + '&selling_plan=' + encodeURIComponent(plan) + '&quantity=1';

      for (var i = 0; i < ctas.length; i++) {
        var a = ctas[i];
        a.setAttribute('href', href);
        a.setAttribute('data-quantity', qty);
        a.setAttribute('data-frequency', freqKey);
        var txt = a.querySelector('[data-s40c-cta-text]');
        if (txt && a.getAttribute('data-cta-location') !== 'sticky') {
          txt.textContent = qty + '個・' + freqLabel + 'で申し込む';
        }
      }

      for (var t = 0; t < elTotal.length; t++) elTotal[t].textContent = yen(total);
      for (var b = 0; b < elBreak.length; b++) {
        elBreak[b].textContent = '商品' + yen(price) + '円 ＋ 関東送料' + yen(ship) + '円';
      }
      if (elLabel) {
        elLabel.textContent = '定期便 ' + qty + '個（10個パック×' + packs + '）／' + freqLabel;
      }
      if (elUnit) elUnit.textContent = unit;
      if (fabTotal) fabTotal.textContent = yen(total) + '円';
      if (fabPlan) fabPlan.textContent = qty + '個・' + freqLabel;
      if (fabBreak) {
        fabBreak.textContent = '／1回（商品' + yen(price) + '円＋関東送料' + yen(ship) + '円）';
      }
    }

    for (var a = 0; a < qtyInputs.length; a++) qtyInputs[a].addEventListener('change', sync);
    for (var b = 0; b < freqInputs.length; b++) freqInputs[b].addEventListener('change', sync);

    sync();
  }

  for (var i = 0; i < roots.length; i++) init(roots[i]);
})();
